import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Button, Image } from '@components/ui';

import styles from './ProductToastBody.module.scss';

const ProductToastBody = (props) => {

  const {
    className, product, button, message = ''
  } = props;

  const { name, image } = product || {};
  const { label: buttonLabel, props: buttonProps } = button || {};

  return (
    <div className={classnames(styles.root, className)}>
      <div className={styles.thumbnail}>
        <Image
          className={styles.image}
          src={image}
          width={52}
          height={52}
          quality={100}
          optimize
          alt={name}
        />
      </div>
      <div className={styles.content}>
        <div className={styles.message}>
          {message}
        </div>
        {
          button && (
            <Button
              size="small"
              type="button"
              variant="subtle"
              className={styles.button}
              {...buttonProps}
            >
              {buttonLabel}
            </Button>
          )
        }
      </div>
    </div>
  );
};

ProductToastBody.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  product: PropTypes.shape({ name: PropTypes.string, image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]) }),
  button: PropTypes.shape({ prop: PropTypes.shape({}), label: PropTypes.string }),
  message: PropTypes.string,
};

export default ProductToastBody;
